import { useState } from "react";
import logo from "../../assets/images/mtstaj1.png";
import applynowbtn from "../../assets/images/applynowbtn2.png";
import Sun from "../../assets/images/sun.png";
import Star from "../../assets/images/star.png";

//*Components
import Footer from "../Footer";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  const OpenMenu = () => {
    setToggle(true);
    document.body.style.overflowY = "hidden";
  };
  const CloseMenu = () => {
    setToggle(false);
    document.body.style.overflowY = "auto";
  };

  return (
    <section className="w-full flex justify-center z-10 absolute">
      <div className="w-4/5 max-w-screen-xl flex flex-row justify-between items-center">
        <div className="">
          <a href="/">
            <img
              loading="lazy"
              className="w-[57px] sm:w-[100px] md:w-[147px]"
              src={logo}
              alt="mtstaj-logo"
            />
          </a>
        </div>
        <div className="hidden lg:block">
          <ul
            style={{ fontFamily: "Poppins" }}
            className="flex flex-row space-x-9 items-center"
          >
            <li>
              <a
                className="text-[18px] font-normal hover:font-bold p-2 hover:p-1 transition-all duration-200"
                href="#mt-staj-programlari-zirvesi-nedir"
              >
                MT&Staj Programları Zirvesi Nedir?
              </a>
            </li>
            <li className="text-[18px] font-normal hover:font-bold p-2 hover:p-1 transition-all duration-200">
              <a href="#kimler-katilabilir">Kimler Katılabilir?</a>
            </li>
            <li>
              <a
                className="text-[18px] font-normal hover:font-bold p-2 hover:p-1 transition-all duration-200"
                href="#program-akisi"
              >
                Program Akışı
              </a>
            </li>
            <li>
              <a
                className="text-[18px] font-normal hover:font-bold p-2 hover:p-1 transition-all duration-200"
                href="#sss"
              >
                S.S.S
              </a>
            </li>
          </ul>
        </div>
        <div className="hidden lg:block">
          <a href="#kayit-ol">
            <img
              loading="lazy"
              className="w-[176px]"
              src={applynowbtn}
              alt="applynowbtn"
            />
          </a>
        </div>
        <div
          onClick={() => {
            OpenMenu();
          }}
          className="lg:hidden block border border-[#FDC343] h-[32px] w-[32px] group"
        >
          <button className="flex flex-col space-y-1 p-2 rounded-md h-full justify-center">
            <div className="w-[15px] h-[1px] bg-[#707070] rounded-sm group-hover:bg-[#000]"></div>
            <div className="w-[15px] h-[1px] bg-[#707070] rounded-sm group-hover:bg-[#000]"></div>
            <div className="w-[15px] h-[1px] bg-[#707070] rounded-sm group-hover:bg-[#000]"></div>
          </button>
        </div>
      </div>
      <div
        className={
          toggle
            ? "block w-screen1 h-screen1 fixed bg-[#EF7C61] top-0 left-0 bottom-0 right-0 z-10 py-0 overflow-hidden select-none"
            : "hidden w-screen1 h-screen1 fixed bg-[#EF7C61] top-0 left-0 bottom-0 right-0 z-10 py-0  overflow-hidden select-none"
        }
      >
        <img
          loading="lazy"
          className="absolute top-10 left-5 w-[50px] h-[50px]"
          src={Star}
          alt="star"
        />
        <div
          onClick={CloseMenu}
          className="w-[50px] h-[50px] border border-[#FDC343] bg-white fixed top-5 right-[10%] flex justify-center items-center text-[#707070] font-bold hover:text-gray-700 transition-all duration-100"
        >
          <div className="w-[23px] h-[1px] bg-[#707070] absolute rotate-45"></div>
          <div className="w-[23px] h-[1px] bg-[#707070] absolute -rotate-45"></div>
        </div>
        <div className="w-full h-[80%] flex flex-col justify-center items-center space-y-4">
          <ul className="w-4/5 flex flex-col space-y-3">
            <li
              style={{ fontFamily: "Poppins" }}
              className=" bg-white p-2 text-center"
            >
              <a
                className="block w-full h-full text-[21px] text-[#244C5A] font-normal hover:font-bold"
                onClick={CloseMenu}
                href="#mt-staj-programlari-zirvesi-nedir"
              >
                MT&Staj <br /> Programları Zirvesi Nedir?
              </a>
            </li>
            <li
              style={{ fontFamily: "Poppins" }}
              className=" bg-white p-2 text-center"
            >
              <a
                className="block w-full h-full text-[21px] text-[#244C5A] font-normal hover:font-bold"
                onClick={CloseMenu}
                href="#kimler-katilabilir"
              >
                Kimler Katılabilir?
              </a>
            </li>
            <li
              style={{ fontFamily: "Poppins" }}
              className=" bg-white p-2 text-center"
            >
              <a
                className="block w-full h-full text-[21px] text-[#244C5A] font-normal hover:font-bold"
                onClick={CloseMenu}
                href="#program-akisi"
              >
                Program Akışı
              </a>
            </li>
            <li
              style={{ fontFamily: "Poppins" }}
              className=" bg-white p-2 text-center"
            >
              <a
                className="block w-full h-full text-[21px] text-[#244C5A] font-normal hover:font-bold"
                onClick={CloseMenu}
                href="#sss"
              >
                S.S.S
              </a>
            </li>
          </ul>
          <div>
            <div>
              <a onClick={CloseMenu} href="#kayit-ol">
                <img
                  loading="lazy"
                  className="w-[176px]"
                  src={applynowbtn}
                  alt="applynowbtn"
                />
              </a>
            </div>
          </div>
        </div>
        <div className="w-full h-[20%] absolute -bottom-1 left-0 bg-[#FFF8EB] flex items-end">
          <Footer />
        </div>
        <img
          loading="lazy"
          className="w-36 absolute bottom-[12%] right-10"
          src={Sun}
          alt="sun"
        />
      </div>
    </section>
  );
};

export default Navbar;
